import {
  PLACEMENT_REVENUE_REPORT_REQUEST,
  PLACEMENT_REVENUE_REPORT_SUCCESS,
  PLACEMENT_REVENUE_REPORT_FAIL,
} from "./actionType";

const initialState = {
  placementRevenueReportSummary: null,
  placementRevenueReportGroups: [],
  placementRevenueReportLoading: false,
  placementRevenueReportError: null,
};

const PlacementRevenueReport = (state = initialState, action) => {
  switch (action.type) {
    case PLACEMENT_REVENUE_REPORT_REQUEST:
      return {
        ...state,
        placementRevenueReportLoading: true,
        placementRevenueReportError: null,
      };

    case PLACEMENT_REVENUE_REPORT_SUCCESS:
      return {
        ...state,
        placementRevenueReportLoading: false,
        placementRevenueReportSummary:
          action.payload?.staffshiftrevenue_summary || null,
        placementRevenueReportGroups:
          action.payload?.staffshiftrevenue_groups || [],
      };

    case PLACEMENT_REVENUE_REPORT_FAIL:
      return {
        ...state,
        placementRevenueReportLoading: false,
        placementRevenueReportError: action.payload,
      };

    default:
      return state;
  }
};

export default PlacementRevenueReport;
